"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSitePagesAsSelectInputOptions = exports.getTotalSitePages = exports.getFetchPublishedPagesByIdRequestStatus = exports.getFetchPublishedPagesRequestStatus = exports.getSitePages = void 0;

var _constants = require("./constants");

var _reselect = require("reselect");

var getSitePages = function getSitePages(state) {
  return state[_constants.SITE_PAGES];
};

exports.getSitePages = getSitePages;
var getFetchPublishedPagesRequestStatus = (0, _reselect.createSelector)([getSitePages], function (sitePages) {
  return sitePages.get('requestStatus');
});
exports.getFetchPublishedPagesRequestStatus = getFetchPublishedPagesRequestStatus;
var getFetchPublishedPagesByIdRequestStatus = (0, _reselect.createSelector)([getSitePages], function (sitePages) {
  return sitePages.get('requestStatusById');
});
exports.getFetchPublishedPagesByIdRequestStatus = getFetchPublishedPagesByIdRequestStatus;
var getTotalSitePages = (0, _reselect.createSelector)([getSitePages], function (pages) {
  return pages.get('total');
});
exports.getTotalSitePages = getTotalSitePages;
var getSitePagesAsSelectInputOptions = (0, _reselect.createSelector)([getSitePages], function (pages) {
  return pages.get('publishedPages').reduce(function (acc, page) {
    acc.push({
      value: page.get(_constants.PageProperties.ID),
      text: page.get(_constants.PageProperties.NAME),
      url: page.get(_constants.PageProperties.URL)
    });
    return acc;
  }, []);
});
exports.getSitePagesAsSelectInputOptions = getSitePagesAsSelectInputOptions;